/* eslint-disable react/prop-types */
// 送信一覧のリスト

/*-------------------
    モジュールのimport
---------------------*/
import React, { useState } from 'react';

/*-------------------
   クラスのimport
 ---------------------*/
import * as commons from '../commons';

// 送信履歴の作成
const SendTableRow = ({ data, insertCode, accountInfo, groupInfo = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { send_info: sendInfo = '' } = data;
  const {
    title: tmpTitle = '',
    main: tmpMain = '',
    group_name: groupName = '',
    group = [],
    time: sendTime = '',
  } = sendInfo;
  const { group_flag: groupFlag = '' } = accountInfo;

  let title = tmpTitle;
  let main = tmpMain;
  for (let i = 0; i < insertCode.length; i += 1) {
    const { code, name } = insertCode[i];
    title = title.replace(new RegExp(code, 'g'), `_${name}_`);
    main = main.replace(new RegExp(code, 'g'), `_${name}_`);
  }

  // グループマスタの全idが配信先グループに含まれている場合も「全て」表示にする。
  const isAllGroups =
    group.length === 0 ||
    (groupInfo.length > 0 && groupInfo.every(({ id = '' }) => group.includes(id)));
  const groupDisp = isAllGroups ? '全て' : groupName.toString();

  const detail = (
    <div className="flex-box">
      <div style={{ flex: 1 }}>
        <div className="show-col">
          <div className="bold">配信日</div>
          <div className="ml10">{commons.changeJapanDate(sendTime)}</div>
        </div>
        {groupFlag ? (
          <div className="show-col">
            <div className="bold"> 配信先</div>
            <div className="ml10">{groupDisp}</div>
          </div>
        ) : null}
        <div className="bold">メール本文</div>
        <div className="ml10">{commons.shapedContents(main)}</div>
      </div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        <td>
          <div className="hide-col">{commons.changeJapanDate(sendTime)}</div>
          <div className="show-col">{commons.changeJapanDate(sendTime, 'MM月DD日 hh時mm分')}</div>
        </td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {title}
          </button>
        </td>
        {groupFlag ? (
          <td className="hide-col">{groupDisp}</td>
        ) : null}
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="3">{detail}</td>
        </tr>
      )}
    </>
  );
};

export default SendTableRow;
